import React from 'react';

export default function TypingIndicator() {
  return (
    <div
      className="typing-indicator"
      role="status"
      aria-label="Assistant is typing"
      data-testid="typing-indicator"
    >
      <span className="typing-dot" />
      <span className="typing-dot" />
      <span className="typing-dot" />
    </div>
  );
}
